<template>
  <div id="allnews" class="allnews">
    <div class="allnews_banner">
      <img
        src="//static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/banner_news.55b1139e.png"
        alt=""
        class="allnews_pc_banner"
      />
    </div>
    <Breadbox />
    <div class="news_inner" id="news_inner">
      <Tabs :tabs="tabs" :currentTab="currentTab" @onClick="handleClick" />
      <div class="newlist_container">
        <div class="newlist" v-for="item in currentNewsList" :key="item.list">
          <a :href="item.href" class="title" target="_blank">{{ item.title }}</a>
          <span class="newdate">{{ item.date }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Tabs from 'vue-tabs-with-active-line';
import Breadbox from '@/components/Breadbox';
import { goTop } from '@/utils/utils';
export default {
  name: 'newsPC',
  props: {
    allnewsList: {
      type: Array,
      default: () => []
    },
    tabs: {
      type: Array,
      default: () => []
    },
    currentTab: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {};
  },
  components: {
    Breadbox,
    Tabs
  },
  computed: {
    currentNewsList() {
      return this.allnewsList.find(item => item.date === this.currentTab)?.list || [];
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, true);
  },
  destroyed: function () {
    window.removeEventListener('scroll', this.onScroll, true);
  },
  methods: {
    onScroll() {
      const scrolled = document.documentElement.scrollTop || document.body.scrollTop;
      const current = document.getElementById('news_inner');
      const tabHeader = current.getElementsByClassName('tabs') && current.getElementsByClassName('tabs')[0];
      const tabContent =
        current.getElementsByClassName('newlist_container') && current.getElementsByClassName('newlist_container')[0];
      const windowHeight = document.documentElement.clientHeight || document.body.clientHeight; // 可视区的高度
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const footerHeight = document.getElementById('contact') && document.getElementById('contact').clientHeight;

      const setStyle = (position, top, marginLeft) => {
        tabHeader.style.position = position;
        tabHeader.style.top = top;
        tabContent.style.marginLeft = marginLeft;
      };

      const allnews = document.getElementById('allnews');
      const allnewsBannerHeight =
        allnews.getElementsByClassName('allnews_banner') &&
        allnews.getElementsByClassName('allnews_banner')[0] &&
        allnews.getElementsByClassName('allnews_banner')[0].clientHeight;
      // 页面滑动到底部时直接定位到最后的footer
      if (
        scrolled + windowHeight >= scrollHeight - 88 - 40 ||
        scrollHeight - scrolled - windowHeight <= footerHeight / 2
      ) {
        setStyle('unset', 0, 0);
      } else if (scrolled > allnewsBannerHeight + 10) {
        setStyle('fixed', '219px', '308px');
      } else {
        setStyle('unset', 0, 0);
      }
    },
    // 左侧年份点击
    clickTab() {
      goTop();
    },
    handleClick(val) {
      this.currentTab = val;
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/function.scss';
@import '@/styles/mixin.scss';

.allnews {
  padding-top: 80px;
}
.allnews_banner {
  text-align: center;
  img {
    width: 100%;
    display: block;
  }
}
::v-deep {
  .tabs__item {
    display: block;
    padding: 0; // 覆盖样式
    padding-bottom: 68px;
    font-size: 16px;
    height: 22px;
    line-height: 22px;
    margin-left: 36px;
    color: #666;
    text-decoration: none;
    border: none;
    background-color: transparent;
    cursor: pointer;
  }
  .tabs__item_active {
    color: $mainActive;
    font-size: 28px;
  }
  .tabs {
    width: 160px;
    margin-right: 148px;
  }
}
.news_inner {
  width: 992px;
  padding: 88px 0;
  margin: 0 auto;
  display: flex;

  .newlist {
    padding-bottom: 40px;
    a {
      display: block;
      height: 28px;
      line-height: 28px;
      font-size: 16px;
      color: #333;
    }
    .newdate {
      line-height: 40px;
      padding-top: 20px;
      font-size: 14px;
      color: #999;
    }
  }
}
</style>
